import {
  BureauActions,
  CREATE_NEW_BUREAU,
  DELETE_BUREAU,
  GET_BUREAU_LIST,
  UPDATE_BUREAU_DETAIL,
} from '../../types/actions/Bureau.actions';
import {BureauObj} from '../../types/models/admin/Bureau';

const initialState: {
  objetList: BureauObj[];
  totalObjets: number;
  selectedObjet: BureauObj | null;
} = {
  objetList: [],
  totalObjets: 0,
  selectedObjet: null,
};

const BureauApp = (state = initialState, action: BureauActions) => {
  switch (action.type) {
    case GET_BUREAU_LIST:
      return {
        ...state,
        objetList: action.payload.list,
        totalObjets: action.payload.total,
      };

    case CREATE_NEW_BUREAU:
      return {
        ...state,
        objetList: [action.payload, ...state.objetList],
        totalObjets: state.totalObjets + 1,
      };

    case DELETE_BUREAU: {
      return {
        ...state,
        objetList: action.payload.list,
        totalObjets: action.payload.total,
      };
    }

    case UPDATE_BUREAU_DETAIL:
      return {
        ...state,
        selectedObjet: action.payload,
        objetList: state.objetList.map(objet =>
          objet.id === action.payload.id ? action.payload : objet,
        ),
      };

    default:
      return state;
  }
};
export default BureauApp;
